<template>
	<div class="structurer">
		<div class="structurer-heading">
			<SidebarArrow
				class="structurer-heading__icon"
				border="#0047ff"
				@click.native="gotoStructurerList"
			/>
			<Heading :title="pageTitle" class="structurer-heading__title" />
		</div>

		<div class="structurer-form" v-if="!isLoading">
			<div class="row">
				<div class="structurer-form-field" ref="name">
					<InputText
						ref="name"
						placeholder="Nome do Estruturador"
						:alert="requiredFields.name"
						v-model="formData.name"
						label="Estruturador: *"
					/>
				</div>
			</div>

			<div class="structurer-form-buttons" :class="!isEditing ? 'new-structurer' : ''">
				<ButtonTertiary
					v-if="isEditing"
					label="Excluir Estruturador"
					size="lg"
					outline
					@click="toggleModal"
				/>
				<ButtonPrimary label="Salvar" size="lg" @click="validateForm" />
			</div>
		</div>

		<div class="structurer__loading">
			<SpinnerIcon v-if="isLoading" />
		</div>

		<Modal
			v-if="isModalOpen"
			title="Excluir Estruturador"
			description="Tem certeza que deseja excluir este Estruturador?"
			primaryLabel="Sim"
			secondaryLabel="Não"
			@secondaryClick="toggleModal"
			@primaryClick="confirmDelete"
		/>
	</div>
</template>
<script>
import ButtonTertiary from '@/components/shared/Button/ButtonTertiary/ButtonTertiary.vue';
import ButtonPrimary from '@/components/shared/Button/ButtonPrimary/ButtonPrimary.vue';
import { scrollToRequiredElement } from '@/utils/scrollToRequiredElement';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import Heading from '@/components/shared/Heading/Heading.vue';
import InputLabel from '@/components/shared/InputLabel/InputLabel.vue';
import InputText from '@/components/shared/InputText/InputText.vue';
import Modal from '@/components/shared/Modal/Modal.vue';
import api from '@/utils/api';

export default {
	name: 'StructurerDetail',
	components: {
		ButtonPrimary,
		ButtonTertiary,
		SidebarArrow,
		SpinnerIcon,
		InputLabel,
		InputText,
		Heading,
		Modal,
	},
	data: () => ({
		http: api.getInstance().http,
		isModalOpen: false,
		isLoading: false,
		data: null,
		formData: {
			structurerType: 1,
		},
		requiredFields: {
			name: false,
		},
	}),
	async created() {
		if (this.isEditing) {
			this.isLoading = true;
			await this.getStructurer();
		}
	},
	methods: {
		gotoStructurerList() {
			this.$router.push({ path: '/dashboard/structurer' });
		},
		async getStructurer() {
			try {
				const id = this.$route.query.id;
				const { data } = await this.http(`/structurer/${id}`);
				this.data = data;
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				this.isLoading = false;
				this.setFormData(this.data);
			}
		},
		setFormData(data) {
			this.formData.name = data.name;
		},
		async saveStructurer() {
			try {
				this.isLoading = true;
				const id = this.$route.query?.id;
				const { data } = await this.http({
					method: 'PATCH',
					url: `structurer/${id}`,
					data: this.formData,
				});
				this.data = data;
				this.$toastr.s('Dados salvos com sucesso');
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				this.isLoading = false;
				this.setFormData(this.data);
			}
		},
		async createStructurer() {
			try {
				this.isLoading = true;
				const { data } = await this.http({
					method: 'Post',
					url: `structurer`,
					data: this.formData,
				});
				this.data = data;
				this.$toastr.s('Estruturador criado com sucesso');
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				this.isLoading = false;
				this.setFormData(this.data);
			}
		},
		async validateForm() {
			let ref;
			Object.keys(this.formData).forEach((property) => {
				if (!this.formData[property]) {
					this.requiredFields[property] = true;
					ref = property;
				} else {
					this.requiredFields[property] = false;
				}
			});

			if (ref) {
				return scrollToRequiredElement(this, ref);
			}
			const callback = this.isEditing ? this.saveStructurer : this.createStructurer;
			await callback();
		},
		async confirmDelete() {
			try {
				this.toggleModal();
				const id = this.$route.query.id;
				this.isLoading = true;
				await this.http({
					method: 'Delete',
					url: `/structurer/${id}`,
				});
				this.$toastr.s('Estruturador deletado com sucesso');
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				this.isLoading = false;
				this.gotoStructurerList();
			}
		},
		toggleModal() {
			this.isModalOpen = !this.isModalOpen;
		},
	},
	computed: {
		isEditing() {
			return !!this.$route.query?.id;
		},
		pageTitle() {
			return this.isEditing ? 'Editar Estruturador' : 'Adicionar Estruturador';
		},
	},
};
</script>
<style lang="scss" scoped>
@import './StructurerDetail.scss';
</style>
